import OregonCityPageTemplate from "@/pages/oregon-city/CityPageTemplate";
import { woodburnConfig } from "./data";

export default function WoodburnPage() {
  return <OregonCityPageTemplate config={woodburnConfig} />;
}